import React, { useState } from "react"
import styles from "./FlashCards.module.scss"
import cn from "clsx"

const renderPagination = (i: number, n: number, setIndex: (x: number) => void) => {
    return (
        <div className={styles.pagination}>
            {Array.from(Array(n).keys()).map((j: number) => (
                <div
                    key={j}
                    className={i === j ? styles.active : ""}
                    onClick={() => setIndex(j)}></div>
            ))}
        </div>
    )
}

const FlashCards: React.FC<{ message: any }> = ({ message }) => {
    const [flipped, setFlipped] = useState(false)
    const [index, setIndex] = useState(0)
    const flip = () => setFlipped(!flipped)

    if (!message.includes("<item>")) return <p>Generating flashcards...</p>

    const itemPattern = /<item>Q: (.*?) \/ A: (.*?)<\/item>/g
    const flashcards = []
    let match

    while ((match = itemPattern.exec(message)) !== null) {
        const question = match[1]
        const answer = match[2]
        flashcards.push([question, answer])
    }

    const next = () => {
        if (flashcards.length > index + 1) setIndex(index + 1)
        else setIndex(0)
        setFlipped(false)
    }

    const previous = () => {
        if (index > 0) setIndex(index - 1)
        else setIndex(flashcards.length - 1)
        setFlipped(false)
    }

    return (
        <div className={cn(styles.root)}>
            <div className={styles.cardContainer}>
                <div className={cn(styles.card, !flipped ? styles.active : null)} onClick={flip}>
                    <span className={styles.question}>{flashcards[index][0]}</span>
                    <span className={styles.hint}>Tap to see the answer</span>
                </div>

                <div className={cn(styles.card, flipped ? styles.active : null)} onClick={flip}>
                    <span className={styles.question}>{flashcards[index][1]}</span>
                    <span className={styles.hint}>Tap to see question again</span>
                </div>

                {renderPagination(index, flashcards.length, setIndex)}

                <div className={styles.nextButton} onClick={next}>
                    <i className="material-symbols-rounded">arrow_forward</i>
                </div>
                <div className={styles.previousButton} onClick={previous}>
                    <i className="material-symbols-rounded">arrow_back</i>
                </div>
            </div>
        </div>
    )
}

export default FlashCards
